"use strict";
// Return a random base-36 uid, optionally postfixed with a key.
// Example:
//  uid() === 'e4t81q'
//  uid('MyComponent') === 'acta01-MyComponent'
Object.defineProperty(exports, "__esModule", { value: true });
var uid = function (key, length) {
    if (length === void 0) { length = 6; }
    return [
        Math.round(Math.pow(36, length + 1) - Math.random() * Math.pow(36, length))
            .toString(36)
            .slice(1),
        key ? "-" + key : '',
    ].join('');
};
exports.default = uid;
